module.exports = __webpack_public_path__ + "b438637444e4d6f5fae5f6805272fef5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/dollar_general_2022_chart.png
// module id = 1666
// module chunks = 0